<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="
            $router.push({
              name: 'Home',
            })
          "
        >
          Menú
        </v-btn>
        <br />
        <br />
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          xl="12"
          lg="12"
          v-if="active == 0"
        >
          <v-alert prominent type="info">
            Servicio temporalmente inactivo
          </v-alert>
        </v-col>
        <div v-else>
          <v-row>
            <v-col md="12">
              <v-card
                elevation="0"
                style="background-color: #eff4f5"
                v-if="user.tipoUsuario == 'empresa'"
              >
                <v-card-text class="flex-shrink-1">
                  <div style="position: absolute; top: 50px; z-index: 1000">
                    <VEmojiPicker
                      class="elevation-1"
                      @select="selectEmoji"
                      emojiSize="25"
                      emojisByRow="9"
                      v-if="showEmojis"
                    />
                  </div>

                  <template>
                    <Mentionable
                      :keys="['@', '#']"
                      :items="followings"
                      offset="6"
                      insert-space
                      @search="searchText = $event"
                      @open="openKey = $event"
                      @close="closeKey = $event"
                      @apply="(item, key) => selectItem(item)"
                    >
                      <v-textarea
                        v-model.trim="content"
                        label="Descripción de la oferta laboral"
                        type="text"
                        no-details
                        prepend-icon="mdi-emoticon"
                        @click:prepend="showEmojis = !showEmojis"
                        @click="showEmojis = false"
                        @focus="showEmojis = false"
                        hide-details
                        name="input-7-4"
                        rows="3"
                        solo
                      >
                        <template slot="append">
                          <v-icon
                            color="green"
                            @click="uploadFilesEvent()"
                            title="Adjuntar imagen"
                            >mdi-file-image</v-icon
                          >
                          <v-icon
                            color="orange"
                            @click="uploadVideoEvent()"
                            title="Adjuntar video"
                            >mdi-file-video</v-icon
                          >
                        </template>
                      </v-textarea>

                      <template #no-result>
                        <div class="dim">No result</div>
                      </template>

                      <template #item-@="{ item }">
                        <div class="user">
                          <v-avatar size="25" color="#636E72">
                            <v-img
                              :src="item.Avatar"
                              v-if="item.Avatar"
                            ></v-img>
                            <v-icon dark v-else>mdi-image</v-icon>
                          </v-avatar>
                          {{ item.value }}
                        </div>
                      </template>
                    </Mentionable>
                  </template>

                  <input
                    id="file-upload"
                    type="file"
                    @change="onFileChange"
                    ref="fileInput"
                    style="visibility: hidden"
                    multiple=""
                  />
                  <input
                    id="file-upload"
                    type="file"
                    @change="onVideoChange"
                    ref="fileInputVideo"
                    style="visibility: hidden"
                  />

                  <v-row>
                    <v-chip
                      class="ma-2"
                      close
                      color="#f2f2f2"
                      close-icon="mdi-delete"
                      text-color="primary"
                      v-for="(file, index) in files"
                      :key="index"
                      @click:close="
                        file.id
                          ? deleteFileThumnail(index, file.id)
                          : deleteFileThumnail(index, null)
                      "
                    >
                      <v-sheet
                        color="white"
                        elevation="1"
                        height="100"
                        width="100"
                        class="m-10 p-5 preview"
                      >
                        <img :src="file.image" v-if="file.id" />
                        <img :src="file.url" v-else />
                      </v-sheet>
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      close
                      color="#f2f2f2"
                      close-icon="mdi-delete"
                      text-color="primary"
                      @click:close="video = null"
                      v-if="video"
                    >
                      <v-sheet
                        color="white"
                        elevation="1"
                        height="100"
                        width="100"
                        class="
                          m-10
                          p-5
                          preview
                          d-flex
                          align-center
                          justify-center
                          pa-4
                          mx-auto
                        "
                      >
                        <v-icon x-large color="#2D3436" class="mx-auto"
                          >mdi-filmstrip</v-icon
                        >
                      </v-sheet>
                    </v-chip>
                  </v-row>
                </v-card-text>
                <v-card-actions style="padding: 16px" class="pl-12">
                  <v-select
                    v-model="cargo"
                    :items="cargos"
                    :rules="[(v) => !!v || 'Item is required']"
                    label="Categoria"
                    item-text="name"
                    item-value="id"
                    required
                  ></v-select>

                  <div class="ml-5 mr-5">
                    
                    ó
                  </div>

                  <v-text-field
                    v-model="cargoNuevo"
                    :counter="20"
                    label="Nuevo Cargo"
                    required
                  ></v-text-field>

                  <v-btn
                    depressed
                    color="primary"
                    @click="editPost()"
                    v-if="action == 'edit'"
                  >
                    Editar </v-btn
                  ><v-btn
                    depressed
                    color="danger"
                    @click="cancel()"
                    v-if="action == 'edit'"
                  >
                    Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    color="info"
                    @click="$router.push('profile/empresa')"
                    class="ml-5"
                  >
                    <v-avatar
                      size="25"
                      title="Ver perfil"
                      style="cursor: pointer"
                    >
                      <div
                        class="v-image v-responsive theme--light"
                        v-if="user.imagen"
                      >
                        <div
                          class="v-responsive__sizer"
                          style="padding-bottom: 190.399%"
                        ></div>
                        <div
                          class="v-image__image v-image__image--cover"
                          v-bind:style="{
                            'background-image': 'url(' + user.imagen + ')',
                            'background-position': 'center center',
                          }"
                        ></div>
                        <div
                          class="v-responsive__content"
                          style="width: 1229px"
                        ></div>
                      </div>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-avatar>
                    Ver mi perfil
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    @click="addPostulacion()"
                    v-if="action == 'add' && !usuarioBorrado && !user.excedente"
                  >
                    Publicar
                  </v-btn>
                </v-card-actions>
              </v-card>

              <v-card elevation="0" style="background-color: #eff4f5" v-else>
                <v-card-text class="flex-shrink-1">
                  <v-row>
                    

                    <v-col class="d-flex" cols="6" sm="3" md="3">
                      <v-select
                        :items="cargos"
                        v-model="cargo"
                        item-text="name"
                        item-value="id"
                        label="Mostrar Todos"
                        solo
                        dense
                        @change="verCargo()"
                      ></v-select>

                      <v-btn
                      depressed
                      color="warning"
                      @click="verAll()"
                      class="ml-5"
                    >
                      Ver todo
                    </v-btn>
                    </v-col>

                    

                    <v-col class="d-flex" cols="6" sm="6" md="4">
                      <v-file-input
                        dense
                        v-model="files1"
                        color="deep-purple accent-4"
                        counter
                        label="haz click aca para cargar tu cv!"
                        multiple
                        placeholder="Select your files"
                        prepend-icon=""
                        outlined
                        :show-size="1000"
                        ref="fileInputCv"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                          >
                            {{ text }}
                          </v-chip>

                          <span
                            v-else-if="index === 2"
                            class="text-overline grey--text text--darken-3 mx-2"
                          >
                            +{{ files1.length - 2 }} File(s)
                          </span>
                        </template>
                      </v-file-input>

                      <v-btn
                        depressed
                        color="primary"
                        @click="guardarCv()"
                        class="ml-5"
                      >
                        Guardar CV
                      </v-btn>
                    </v-col>
                  </v-row>

                 
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <br />
          <div class="text-center">
            <v-progress-circular
              indeterminate
              v-if="loading"
              color="primary"
            ></v-progress-circular>
          </div>
          <br />
          <v-divider></v-divider>
          <br />

          <v-container>
            <masonry
              :gutter="{ default: '30px', 700: '15px' }"
              :cols="{ default: 2, 1000: 2, 700: 1, 500: 1 }"
            >
              <v-card
                v-for="item in publicationsFiltered"
                :key="item.id"
                class="mt-2 mb-2"
                elevation="1"
                flat
              >
                <v-list-item v-if="item.empresa != null" two-line>
                  <v-list-item-icon>
                    <v-avatar
                      size="50"
                      color="#636E72"
                      style="cursor: pointer"
                      title="Ver perfil"
                      @click="openProfile(item.empresa.id, 'empresa')"
                    >
                      <v-img :src="item.empresa.image"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-h6">
                      {{ item.empresa.razon_social }} <br>
                       Cargo : {{ item.cargo.name  }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      ><small
                        >Descripcion: {{item.empresa.descripcion }}</small
                      ></v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      ><small
                        >Hace {{ gettime(item.updated_at) }}</small
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                

                <v-carousel
                  hide-delimiters
                  :show-arrows="
                    item.images.length >= 2 ||
                    (item.images.length == 1 && item.video)
                      ? true
                      : false
                  "
                  v-if="item.images.length >= 2 || item.video"
                  height="300"
                >
                  <v-carousel-item
                    v-for="(image, j) in item.images.filter((d) => {
                      return d.active == 1;
                    })"
                    :key="j"
                    :src="image.image"
                    @click="openPublication(item)"
                  ></v-carousel-item>
                  <v-carousel-item v-if="item.video">
                    <iframe
                      v-if="item.video"
                      width="100%"
                      height="300"
                      :src="item.video"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                      class="mt-10"
                    ></iframe>
                  </v-carousel-item>
                </v-carousel>
                <v-img
                  @click="openPublication(item)"
                  v-if="item.images.length == 1"
                  :src="item.images[0].image"
                ></v-img>
                <v-card-text
                  style="color: #424242"
                  v-html="item.contentHtml"
                >
                </v-card-text>
                <v-card-text style="color: #424242" class="mt-0 pt-0 pb-2 mb-2">
                  <div v-if="user.tipoUsuario == 'empresa'">
                    <v-btn
                      depressed
                      color="red"
                      @click="eliminar(item)"
                      class="ml-5"
                      style="color: #eff4f5"
                    >
                      Eliminar
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn
                      depressed
                      color="primary"
                      class="ml-5"
                      v-if="
                        item.postulados.filter((d) => {
                          return (
                            d.work_bags_id == item.id &&
                            user.IDStB == d.alumno_id &&
                            d.status === null
                          );
                        }).length > 0
                      "
                    >
                        
                      Postulado
                    </v-btn>

                    <v-btn
                      depressed
                      color="success"
                      class="ml-5"
                      v-else-if="
                        item.postulados.filter((d) => {
                          return (
                            d.work_bags_id == item.id &&
                            user.IDStB == d.alumno_id &&
                            d.status == 'aceptado'

                          );
                        }).length > 0
                      "
                    >
                    
                     aceptado
                    </v-btn>

                    <v-btn
                      depressed
                      color="red"
                      class="ml-5 white--text"
                      v-else-if="
                        item.postulados.filter((d) => {
                          return (
                            d.work_bags_id == item.id &&
                            user.IDStB == d.alumno_id &&
                            d.status == 'rechazado'

                          );
                        }).length > 0
                      "
                    >
                    
                     rechazado
                    </v-btn>

                    <v-btn
                      depressed
                      color="warning"
                      @click="postulacion(item)"
                      class="ml-5"
                      v-else
                    >
                      Postularme
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </masonry>
          </v-container>

          <v-row>
            <p
              class="
                m-10
                p-5
                preview
                d-flex
                align-center
                justify-center
                pa-4
                mx-auto
              "
              v-if="current_page == last_page"
            >
              No hay mas publicaciones para mostrar
            </p>
          </v-row>
        </div>
      </v-col>

      <Publication :publication="publicationSelected" />

      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import Publication from "../../components/Publication";
import moment from "moment";
import { VEmojiPicker } from "v-emoji-picker";
import { Mentionable } from "vue-mention";

moment.locale("es");
export default {
  name: "BolsaTrabajo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    Publication,

    VEmojiPicker,
    Mentionable,
  },

  data: () => ({
    cargoNuevo:"",
    files1: [],
    cargo: "",
    title: "Bolsa-trabajo",
    content: "",
    content2: "",
    selection: 1,
    show: false,
    contentAlert: "",
    typeAlert: "modal-info",
    showPublication: false,
    publications: [],
    imageSelected: "",
    publicationSelected: null,
    loading: false,
    url: null,
    files: [],
    limit: 10,
    video: null,
    current_page: 0,
    last_page: -1,
    action: "add",
    publication: null,
    current_index: null,
    images_deleted: [],
    active: 1,
    showEmojis: false,
    followers: [],
    followings: [],
    tipoUsuario: "",
    options: {
      width: 300,
      padding: {
        default: 12,
        5: 3,
        6: 3,
      },
    },
    cargos: [],
    selecteds: [],
    items: [],
    getAll: 0,
    usuarioBorrado: "",
  }),

  mounted() {
    this.tipoUsuario = this.user.tipoUsuario;
    this.getPublications();
    this.getCargos();
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    
    publicationsFiltered() {
      const result = [];
      for (const p of this.publications) {
        p.contentHtml = p.content;
        if (p.taggeds && p.taggeds.length > 0) {
          p.taggeds.forEach((val) => {
            let t = new Date().getTime();
            p.contentHtml = p.contentHtml.replace(
              val.shortName.trim(),
              '<a class="tagged" href="profile/' +
                val.IDStB +
                "?t=" +
                t +
                '">' +
                val.shortName.trim() +
                "</a>"
            );
          });
        }
        result.push(p);
      }

      return result;
    },
  },
  methods: {
    openProfile(id, tipo_usuario) {
      this.$router.push({
        name: "ProfileEmpresa",
        params: {
          id: id,
          tipo_usuario: tipo_usuario,
        },
        query: {
          t: new Date().getTime(),
        },
      });
    },
    async getCargos() {
      this.$API
        .get(
          {
            url: "cargos",
          },
          false
        )
        .then((res) => {
          this.cargos = res;
        });
    },

    async getPublications(reload = false) {
      if (this.current_page !== this.last_page || reload) {
        this.loading = true;
        this.current_page++;
        

        this.$API
          .get(
            {
              url:
                "work-bag?page=" +
                this.current_page +
                "&getAll=" +
                this.getAll +
                "&cargo=" +
                this.cargo,
            },
            false
          )
          .then((res) => {
            if (reload) {
              this.publications = res.data;
            } else {
              this.publications.push(...res.data);
            }

            if (this.tipoUsuario == "empresa") {
              this.publications = this.publications.filter(
                (publication) => publication.business_id == this.user.IDStB
              );
            }

            this.current_page = res.current_page;
            this.last_page = res.last_page;
            this.loading = false;
          });
      }
    },

    

    selectEmoji(emoji) {
      console.log(emoji);
      this.content += emoji.data;
    },

    async guardarCv() {
      var formData = new FormData();
      formData.append("alumno_id", this.user.IDStB);
      formData.append("curriculum", this.files1[0]);

      let url = "alumno-cv/upload";
      await this.$API
        .post({
          url: url,
          data: formData,
        })
        .then(() => {
          this.files1 = [];
        });
    },

    postulacion(postulacion) {
      this.$API
        .post(
          {
            url: "postulacion",
            data: { usuario: this.user, postulacion: postulacion },
          },
        )
        .then(() => {
          this.verAll(true);
        });
    },

    eliminar(postulacion) {
      this.$API
        .get(
          {
            url: "postulacion-delete/" + postulacion.id,
          },
          false
        )
        .then(() => {
          this.$API
            .get(
              {
                url:
                  "work-bag?page=" +
                  this.current_page +
                  "&getAll=" +
                  this.getAll,
              },
              false
            )
            .then((res) => {
              this.publications = res.data;

              this.current_page = res.current_page;
              this.last_page = res.last_page;
              this.loading = false;
            });
        });
    },

    async uploadFilesEvent() {
      this.$refs.fileInput.click();
    },

    async uploadVideoEvent() {
      this.$refs.fileInputVideo.click();
    },

    onVideoChange(e) {
      let v = e.target.files[0];
      if (v.type.match("video.*")) {
        this.video = v;
      } else {
        this.typeAlert = "info";
        this.contentAlert = "Agrega un formato válido de video";
        this.show = true;
      }
    },

    onFileChange(e) {
      let all = e.target.files;
      let r = this.files;
      [all].forEach((val) => {
        if (r.length < this.limit) {
          for (const item of val) {
            if (item.type.match("image.*")) {
              item.url = URL.createObjectURL(item);
              r.push(item);
            }
          }
        }
      });
      this.files = Array.from(r);
      if (this.limit == this.files.length) {
        this.contentAlert =
          "El número máximo de imágenes por publicación es " + this.limit;
        this.show = true;
      }
    },

    async addPostulacion() {
    
      if (this.content) {
        var formData = new FormData();

        formData.append("cargo", this.cargo);
        formData.append("content", this.content);
        formData.append("cargoNuevo" , this.cargoNuevo);
        if (this.files.length > 0) {
          formData.append("cantidadImagen", this.files.length);
          let i = 0;
          for (let file of this.files) {
            formData.append(`imagen_${i}`, file, file.name);
            i++;
          }
        }
        if (this.video) {
          formData.append("video", this.video);
        }

        if (this.selecteds.length > 0) {
          let taggeds = new Array();
          this.selecteds.forEach((val) => {
            if (this.content.includes(val.value)) {
              taggeds.push(val.id);
            }
          });
          formData.append("tagged", taggeds.join(","));
        }
        console.log(formData);

        await this.$API
          .post({
            url: "crear-postulacion",
            data: formData,
          })
          .then((res) => {
            this.publications.unshift(res);
            this.content = "";
            this.files = [];
            this.video = null;
            this.verAll();
          });
      } else {
        this.contentAlert =
          "Para poder publicar su post debes ingresar un texto";
        this.show = true;
      }
    },

    gettime(date_publish) {
      let current_date = moment();
      let published_date = moment(date_publish);
      return moment.duration(current_date - published_date).humanize();
    },

    onScroll() {
      console.log(
        document.body.scrollHeight - window.innerHeight - window.top.scrollY
      );
      if (
        document.body.scrollHeight - window.innerHeight - window.top.scrollY <=
        500
      ) {
        this.getPublications();
      }
    },

    getColor() {
      let colors = ["#2D3436", "#636E72", "#E8563F", "#C9412B", "#1F2526"];
      let min = 0;
      var max = colors.length;
      var random = Math.floor(Math.random() * (max - min)) + min;
      return colors[random];
    },

    verAll() {
      this.cargo = 0;
      this.getAll = this.getAll == 0 ? 1 : 0;
      this.current_page = 0;
      this.getPublications(true);
    },

    verCargo() {
      
      this.getAll = this.getAll == 0 ? 1 : 0;
      this.current_page = 0;
      this.getPublications(true);
    },
  },
  
};
</script>
  <style>
.v-card__subtitle,
.v-card__text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 0.95rem !important;
  letter-spacing: 0.007143em;
}
.preview {
  margin: 10px;
}
.preview img {
  margin: 5px;
  max-width: 90%;
}
.v-chip.v-size--default {
  height: auto !important;
}
#EmojiPicker {
  width: 380px;
  background-color: white;
  border: none;
}
.item {
  padding: 16px 24px;
  border-radius: 3px;
  background: #f5f5f5;
}
.v-carousel__item .v-image__image--cover {
  background-size: contain;
}
.atwho-ul {
  padding-left: 0 !important;
}
.v-application--is-ltr
  .v-textarea.v-text-field--enclosed
  .v-text-field__slot
  textarea {
  /* visibility: hidden;*/
}
.tagged {
  font-weight: bold;
  text-decoration: none;
}
.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
  font-family: "Roboto", sans-serif !important;
  font-size: 14px;
}

.mention-selected {
  background: #2D3436;
  color: white;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 12px;
  border-radius: 5px;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
}
.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
}
</style>
